module.exports = __webpack_public_path__ + "img/numero_movil.1f8b51e3.svg";